export default __webpack_public_path__ + "static/media/ee.5ea34c7e.svg";